import { useCallback } from 'react';
import '@myriadgenetics/tokens/dist/tokens.css';
import { ReactComponent as PatientAvatarIcon } from '../../assets/icons/patient-avatar.svg';

import './index.scss';

export interface ButtonProps {
  className?: string;
  dataTestId?: string;
  children: any;
  disabled?: boolean;
  isChatbotStyle?: boolean;
  onClick?: () => void;
  isSelected?: boolean;
  showContinueButton?: boolean;
  isBackButton?: boolean;
  secondary?: boolean;
}

// This is needed since adding a className removes the default class name from React Aria Components
const baseClass = 'react-Aria-Button';
const secondaryClass = `${baseClass}__secondary-button`;

interface ArrowProps {
  className?: string;
}

const Arrow = ({ className }: ArrowProps) => {
  return (
    <svg className={className} data-testid="arrow-svg" width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.445312 9.25L1.25391 8.47656L8.00391 1.72656L8.8125 0.917969L10.3945 2.5L9.58594 3.30859L3.64453 9.25L9.58594 15.2266L10.3945 16L8.8125 17.6172L8.00391 16.8086L1.25391 10.0586L0.445312 9.25Z"
        fill="#003595"
      />
    </svg>
  );
};

function Button({
  className,
  dataTestId,
  children,
  disabled,
  onClick,
  isChatbotStyle,
  isSelected,
  isBackButton,
  secondary,
  showContinueButton = true,
}: ButtonProps) {
  const isContinueButton = className?.includes('continue-button');

  const handleClick = useCallback(() => {
    if (!disabled && onClick) {
      onClick();
    }
  }, [disabled, onClick]);

  return (
    <>
      <button
        className={`
          ${!showContinueButton ? 'continue-button__hidden' : `${baseClass} ${className}`}
          ${secondary ? secondaryClass : ''}
        `}
        data-testid={dataTestId}
        disabled={disabled}
        onClick={handleClick}
        data-selected={isSelected}
      >
        {isBackButton && <Arrow className="back-button__back-arrow" />}
        {isContinueButton ? children || 'continue' : children}
        {isContinueButton && <Arrow className="continue-button__arrow" />}
      </button>
      {isChatbotStyle && isSelected && (
        <div className="avatar-container">
          <PatientAvatarIcon />
        </div>
      )}
    </>
  );
}

Button.defaultProps = {
  size: 'small',
  disabled: false,
  selected: false,
};

export default Button;
